export const cardStyles = {
  display: 'flex',
  height: '50%',
  width: '65%',
  marginInline: 'auto',
  justifyContent: 'center',
  marginTop: '2rem',
  marginBottom: '2rem',
};

export const boxStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const imageStyles = {
  width: 400,
  height: 250,
  objectFit: 'contain',
};

export const cardContentStyles = {
  flex: '1 0 auto',
  mr: 4,
};

export const infoStyles = {
  display: 'flex',
  alignItems: 'center',
  mt: 1,
  pl: 1,
  pb: 1,
  justifyContent: 'space-around',
};

export const typographyStyles = {
  mt: 1,
  mb: 4,
};
